import React, { useState } from "react";
import { handleGetLanguage } from "../../../utils/languageStorage";

export default function ForgotPassword({ setTogglAuth }) {
    const [email, setEmail] = useState("");
    const [status, setStatus] = useState("");
    const language = handleGetLanguage();

    const handleSubmit = async (e) => {
        e.preventDefault();
        const res = await fetch("https://api.onlybrands.ge/api/password/email", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ email }),
        });

        const data = await res.json();
        setStatus(data.status || data.email);
    };

    return (
        <>
            <div className="text-center">
                <h2 className="text-2xl font-semibold text-orange-600 dark:text-white">
                    {language === "ka" ? "დაგავიწყდა პაროლი?" : "Forgot Your Password?"}
                </h2>
                <p className="text-sm text-slate-400 mt-2">
                    {language === "ka"
                        ? "შეიყვანე შენი ელფოსტა და გამოგიგზავნით ბმულს პაროლის შესაცვლელად. (შეამოწმეთ spam)"
                        : "Enter your email and we’ll send you a reset link. (check Spam)"}
                </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                    <label htmlFor="forgot-email" className="font-medium text-slate-600 dark:text-slate-200">
                        {language === "ka" ? "ელ.ფოსტა:" : "Email address:"}
                    </label>
                    <input
                        id="forgot-email"
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        className="w-full px-4 py-2 mt-2 bg-transparent dark:bg-slate-800 border border-gray-300 dark:border-gray-700 rounded-md text-slate-900 dark:text-white"
                        placeholder={language === "ka" ? "მაგ: name@example.com" : "name@example.com"}
                    />
                </div>

                <button
                    type="submit"
                    className="w-full py-2 bg-orange-600 text-white font-semibold rounded-md hover:bg-orange-700"
                >
                    {language === "ka" ? "პაროლის აღდგენა" : "Send Reset Link"}
                </button>

                {status && (
                    <p className="text-center text-sm text-green-500 mt-2">
                        {status}
                    </p>
                )}

                <div className="text-center text-sm text-slate-500 mt-4">
                    {language === "ka" ? "გახსოვს პაროლი?" : "Remember your password?"}{" "}
                    <button
                        type="button"
                        onClick={() => setTogglAuth("signin")}
                        className="text-orange-600 font-semibold hover:underline"
                    >
                        {language === "ka" ? "შესვლა" : "Sign in"}
                    </button>
                </div>
            </form>
        </>
    );
}
